import axios from 'axios';
import { TokenInfo, TokenResponse } from './Airdrop.types';

export const getAirdropsAsync = async () => {
  const { data } = await axios.get(`/airdrop/tokens`);

  return data.data as TokenResponse;
};
